import { Descriptions, Drawer } from "antd";

import moment from "moment";

function ViewDetail(props: any) {
  let { openViewDetail, setOpenViewDetail, dataViewDetail } =
    props;
  const onClose = () => {
    setOpenViewDetail(false);
  };
  return (
    <>
      <Drawer
        title="Chức năng xem chi tiết"
        width={"50vw"}
        onClose={onClose}
        open={openViewDetail}>
        <Descriptions title="Thông tin phân quyền" bordered column={2}>
          <Descriptions.Item label="ID">
            {dataViewDetail?._id}
          </Descriptions.Item>
          <Descriptions.Item label="Tên api">
            {dataViewDetail?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Link api">
            {dataViewDetail?.apiPath}
          </Descriptions.Item>
          <Descriptions.Item label="Method">
            {dataViewDetail?.method}
          </Descriptions.Item>
          <Descriptions.Item label="Module" span={2}>
            {dataViewDetail?.module}
          </Descriptions.Item>
        
          <Descriptions.Item label="Ngày tạo">
            {moment(dataViewDetail?.createdAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
          <Descriptions.Item label="Ngày cập nhật">
            {moment(dataViewDetail?.updatedAt).format("DD-MM-YY HH:mm:ss")}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
}

export default ViewDetail;
